type GradeAppealSubmissionRecoveryReason = 'already_appealed' | 'window_closed'

type GradeAppealSubmissionError = {
  isStatus: (status: number) => boolean
  response: unknown
}

function isGradeAppealWindowClosedResponse(response: unknown) {
  return (
    typeof response === 'object' &&
    response !== null &&
    'errorCode' in response &&
    response.errorCode === 'APPEAL_WINDOW_CLOSED'
  )
}

export async function recoverGradeAppealSubmission({
  error,
  refresh,
  notify,
  close,
}: {
  error: GradeAppealSubmissionError
  refresh: () => Promise<unknown>
  notify: (reason: GradeAppealSubmissionRecoveryReason) => void
  close: () => void
}): Promise<boolean> {
  const reason = error.isStatus(409)
    ? 'already_appealed'
    : error.isStatus(422) && isGradeAppealWindowClosedResponse(error.response)
      ? 'window_closed'
      : null

  if (!reason) return false

  await refresh()
  notify(reason)
  close()
  return true
}
